var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "actions-collapsed-list" },
    [
      _c(
        "a",
        {
          staticClass: "btn btn-function exit-collapsed-list",
          on: { click: _vm.collapseActions }
        },
        [
          _c("i", {
            staticClass: "glyphicon glyphicon-chevron-left",
            attrs: {
              "aria-hidden": "true",
              "tooltip-placement": "right",
              "uib-tooltip": "Cancel"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "action-icon" }, [
        _c(
          "a",
          { staticClass: "btn btn-list-function", on: { click: _vm.showForm } },
          [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom.hover",
                  value: _vm.$t("EDIT"),
                  expression: "$t('EDIT')",
                  modifiers: { bottom: true, hover: true }
                }
              ],
              staticClass: "fa fa-edit",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "EDIT",
                  expression: "'EDIT'"
                }
              ],
              staticClass: "hint-text-mobile"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-icon" }, [
        _c(
          "a",
          {
            staticClass: "btn btn-list-function",
            attrs: { disabled: _vm.disabled },
            on: { click: _vm.displayDeleteModal }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom.hover",
                  value: _vm.$t("DELETE"),
                  expression: "$t('DELETE')",
                  modifiers: { bottom: true, hover: true }
                }
              ],
              staticClass: "fa fa-trash",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "DELETE",
                  expression: "'DELETE'"
                }
              ],
              staticClass: "hint-text-mobile"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-icon" }, [
        _c(
          "a",
          {
            staticClass: "btn btn-list-function",
            attrs: { disabled: _vm.disabled },
            on: { click: _vm.validate }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom.hover",
                  value: _vm.$t("VALIDATE"),
                  expression: "$t('VALIDATE')",
                  modifiers: { bottom: true, hover: true }
                }
              ],
              staticClass: "fa fa-refresh",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "VALIDATE",
                  expression: "'VALIDATE'"
                }
              ],
              staticClass: "hint-text-mobile"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showDeleteModal
        ? _c(
            "ConfirmationModal",
            {
              attrs: {
                title: _vm.$t("REFERENCES_MODAL_TITLE"),
                "cancel-button-text": _vm.$t("CANCEL"),
                "confirm-action-text": _vm.$t("DELETE"),
                "confirm-button-disabled": _vm.pending || _vm.error,
                "confirm-button-loading": _vm.deleting
              },
              on: {
                confirm: _vm.confirmDeleteModal,
                close: _vm.hideDeleteModal
              }
            },
            [
              _vm.pending || _vm.error
                ? _c("div", [
                    _c(
                      "div",
                      [
                        _vm.pending ? _c("Loader") : _vm._e(),
                        _vm._v(" "),
                        _c("span", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: _vm.checkReferencesText,
                              expression: "checkReferencesText"
                            }
                          ]
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.pending &&
              !_vm.error &&
              _vm.references &&
              !_vm.references.hasReferences
                ? _c("p", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "LABEL_REFERENCES_EMPTY",
                        expression: "'LABEL_REFERENCES_EMPTY'"
                      }
                    ]
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.pending && _vm.references && _vm.references.hasReferences
                ? _c("div", [
                    _c(
                      "span",
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t("LABEL_DELETE_CONFIRMATION_QUESTION")
                            ) +
                            "\n        "
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("i18n", {
                          attrs: {
                            path: "LABEL_DELETE_CONFIRMATION_MESSAGE",
                            tag: "span"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "name",
                                fn: function() {
                                  return [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.currentAuthConnection.name)
                                      )
                                    ])
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            3642654893
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "well well-sm m-t-10 m-b-0" }, [
                      _c("div", { staticClass: "form-horizontal" }, [
                        _vm.references.dynamicinboundcampaignsettings &&
                        _vm.references.dynamicinboundcampaignsettings.length
                          ? _c("div", { staticClass: "row" }, [
                              _c(
                                "label",
                                { staticClass: "col-md-3 control-label" },
                                [
                                  _c("strong", {
                                    directives: [
                                      {
                                        name: "t",
                                        rawName: "v-t",
                                        value: "CAMPAIGNS",
                                        expression: "'CAMPAIGNS'"
                                      }
                                    ]
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-8" }, [
                                _c(
                                  "ul",
                                  {
                                    staticClass:
                                      "list-unstyled form-control-static list-text-overflow"
                                  },
                                  _vm._l(
                                    _vm.references
                                      .dynamicinboundcampaignsettings,
                                    function(campaign) {
                                      return _c(
                                        "li",
                                        {
                                          key:
                                            campaign.dynamicinboundcampaignsettingId
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName: "v-tooltip.right",
                                                  value: _vm.$t(
                                                    "TT_VIEW_CAMPAIGN"
                                                  ),
                                                  expression:
                                                    "$t('TT_VIEW_CAMPAIGN')",
                                                  modifiers: { right: true }
                                                }
                                              ],
                                              attrs: {
                                                target: "_blank",
                                                href: "javascript:;"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.goToCampaign(
                                                    campaign.dynamicinboundcampaignsettingId
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "display-text",
                                                  attrs: {
                                                    title:
                                                      campaign.dynamicinboundcampaignsettingName
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        campaign.dynamicinboundcampaignsettingName
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-external-link m-l-5"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.references.eventcallbacks
                          ? _c("div", { staticClass: "row" }, [
                              _c(
                                "label",
                                { staticClass: "col-md-3 control-label" },
                                [
                                  _c("strong", {
                                    directives: [
                                      {
                                        name: "t",
                                        rawName: "v-t",
                                        value: "PIXELS",
                                        expression: "'PIXELS'"
                                      }
                                    ]
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-8" }, [
                                _c(
                                  "ul",
                                  {
                                    staticClass:
                                      "list-unstyled form-control-static list-text-overflow"
                                  },
                                  _vm._l(
                                    _vm.references.eventcallbacks,
                                    function(eventCallback) {
                                      return _c(
                                        "li",
                                        { key: eventCallback.eventcallbackId },
                                        [
                                          _c(
                                            "a",
                                            {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName: "v-tooltip.right",
                                                  value: _vm.$t(
                                                    "TT_VIEW_PIXEL"
                                                  ),
                                                  expression:
                                                    "$t('TT_VIEW_PIXEL')",
                                                  modifiers: { right: true }
                                                }
                                              ],
                                              attrs: {
                                                target: "_blank",
                                                href: "javascript:;"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.goToPixel(
                                                    eventCallback.eventcallbackId
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "display-text",
                                                  attrs: {
                                                    title:
                                                      eventCallback.eventcallbackName
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        eventCallback.eventcallbackName
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-external-link m-l-5"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.references.pingtreetargets
                          ? _c("div", { staticClass: "row" }, [
                              _c(
                                "label",
                                { staticClass: "col-md-3 control-label" },
                                [
                                  _c("strong", {
                                    directives: [
                                      {
                                        name: "t",
                                        rawName: "v-t",
                                        value: "RING_TREE_TARGETS",
                                        expression: "'RING_TREE_TARGETS'"
                                      }
                                    ]
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-8" }, [
                                _c(
                                  "ul",
                                  {
                                    staticClass:
                                      "list-unstyled form-control-static list-text-overflow"
                                  },
                                  _vm._l(
                                    _vm.references.pingtreetargets,
                                    function(pingtreetarget) {
                                      return _c(
                                        "li",
                                        {
                                          key: pingtreetarget.pingtreetargetId
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName: "v-tooltip.right",
                                                  value: _vm.$t("TT_VIEW_RTT"),
                                                  expression:
                                                    "$t('TT_VIEW_RTT')",
                                                  modifiers: { right: true }
                                                }
                                              ],
                                              attrs: {
                                                target: "_blank",
                                                href: "javascript:;"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.goToRtt(
                                                    pingtreetarget.pingtreetargetId
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "display-text",
                                                  attrs: {
                                                    title:
                                                      pingtreetarget.pingtreetargetName
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        pingtreetarget.pingtreetargetName
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-external-link m-l-5"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              ])
                            ])
                          : _vm._e()
                      ])
                    ])
                  ])
                : _vm._e()
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }